import { lazy } from 'react';

export const PayrollPage = lazy(() =>
  import('@/features/payroll/PayrollPage').then((module) => ({ default: module.PayrollPage })),
);
